<template>
  <div id="container">
    <Header />
    <Nav />
    <div class="overlay hidden-md-up"></div>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
    <Footer />
  </div>
</template>
<script>
import { Header, Nav, Breadcrumb, Footer } from './layout/'
export default {
  name: 'layout',
  components: {
    Header,
    Nav,
    Breadcrumb,
    Footer
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style scoped>
.router-link-active {
  color: red;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.4s ease;
}

.fade-leave-active {
  transition: opacity 0.4s ease;
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// shared/Layout.vue